import React from "react";
import VinanticRoutes from "./routes/VinanticRoutes";

const App = () => <VinanticRoutes />;

export default App;
